import styled from '@emotion/styled';
import {
  FormControlLabel as FormControlLabelMui,
  FormControlLabelProps,
  useRadioGroup,
} from '@mui/material';

import colors from 'styles/sass-variables.module.scss';

const StyledFormControlLabel = styled((props: FormControlLabelProps) => <FormControlLabelMui {...props} />)(
  ({ checked }) => ({
    margin: '0',
    borderRadius: '8px',

    '& .MuiRadio-root': {
      width: '20px',
      height: '20px',
      marginRight: '12px',
    },

    '&.MuiFormControlLabel-root': {
      padding: '8px',
      backgroundColor: checked ? colors.primary_purple_100 : 'transparent',

      '&:not(:last-of-type)': {
        marginBottom: '4px',
      },

      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 1.4,
      },
    },
  }),
);

export const RadioFormControl = (props: FormControlLabelProps) => {
  const radioGroup = useRadioGroup();
  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
};